import { render, staticRenderFns } from "./GestioneLicenze.vue?vue&type=template&id=ead712e0&"
import script from "./GestioneLicenze.vue?vue&type=script&lang=js&"
export * from "./GestioneLicenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports